import { OptionsMenuContainer } from "./OptionsMenuContainer";

export default function OptionsMenuPage() {
  return <OptionsMenuContainer />;
}
